import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';
import { SharedPipesModule } from '@app/@core/pipes/shared-pipes.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LoginNoCaptchaModuleComponent } from './login-no-captcha.component';
import { LoginNoCaptchaRoutingModule } from './login-no-captcha-routing.module';
@NgModule({
  declarations: [LoginNoCaptchaModuleComponent],
  imports: [
    CommonModule,
    LoginNoCaptchaRoutingModule,
    CardModule,
    PasswordModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimengModule,
    ToastModule,
    SharedPipesModule,
    NgOtpInputModule,
    NgxCaptchaModule
  ]
})
export class LoginNoCaptchaModule {}
